import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import useWindowSize from 'hooks/useWindowSize';
import { ReactComponent as ArrowCurved } from 'assets/img/icons/arrow-curved.svg';
import { SCREEN_SIZES } from 'style';
import { StyledTooltipBox, TooltipBoxWrapper } from './styled';

// TooltipBox follows the cursor when followCursor is true.
// Otherwise it hovers in place
const TooltipBox = React.forwardRef(
  ({ showTooltip, children, followCursor, variant = 'default', className }, ref) => {
    const [mousePosition, setMousePosition] = useState({
      x: 0,
      y: 0
    });
    const { width: windowWidth } = useWindowSize();

    useEffect(() => {
      if (!followCursor) return;
      const updateMousePosition = (e) => {
        setMousePosition({
          x: e.clientX,
          y: e.clientY
        });
      };
      window.addEventListener('mousemove', updateMousePosition);
      return () => {
        window.removeEventListener('mousemove', updateMousePosition);
      };
    }, [followCursor]);

    return (
      <AnimatePresence>
        {showTooltip && (
          <TooltipBoxWrapper
            className={className}
            variant={variant}
            $followCursor={followCursor}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ArrowCurved />
            <StyledTooltipBox
              ref={ref}
              variant={variant}
              $followCursor={followCursor}
              style={
                windowWidth >= SCREEN_SIZES.desktop &&
                followCursor && {
                  x: mousePosition.x,
                  y: mousePosition.y + 20
                }
              }
            >
              {children}
            </StyledTooltipBox>
          </TooltipBoxWrapper>
        )}
      </AnimatePresence>
    );
  }
);

TooltipBox.propTypes = {
  showTooltip: PropTypes.bool,
  children: PropTypes.node.isRequired,
  followCursor: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'wide'])
};

export default TooltipBox;
